export const RouterName = {
  home: {
    home: "/:id",
    book: "/booking",
  },
  admin: {
    home: "/admin/:id",
  },
};
